"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var AbstractCustomCodeHelper_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractCustomCodeHelper = void 0;
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../container/ServiceIdentifiers");
const GlobalVariableTemplate1_1 = require("./common/templates/GlobalVariableTemplate1");
const GlobalVariableTemplate2_1 = require("./common/templates/GlobalVariableTemplate2");
const ObfuscationTarget_1 = require("../enums/ObfuscationTarget");
const GlobalVariableNoEvalTemplate_1 = require("./common/templates/GlobalVariableNoEvalTemplate");
const GlobalVariableServiceWorkerTemplate_1 = require("./common/templates/GlobalVariableServiceWorkerTemplate");
let AbstractCustomCodeHelper = AbstractCustomCodeHelper_1 = class AbstractCustomCodeHelper {
    constructor(identifierNamesGeneratorFactory, customCodeHelperFormatter, customCodeHelperObfuscator, randomGenerator, options) {
        this.cachedNode = null;
        this.identifierNamesGenerator = identifierNamesGeneratorFactory(options);
        this.customCodeHelperFormatter = customCodeHelperFormatter;
        this.customCodeHelperObfuscator = customCodeHelperObfuscator;
        this.randomGenerator = randomGenerator;
        this.options = options;
    }
    getNode() {
        if (!this.cachedNode) {
            const codeHelperTemplate = this.getCodeHelperTemplate();
            this.cachedNode = this.customCodeHelperFormatter.formatStructure(this.getNodeStructure(codeHelperTemplate));
        }
        return this.cachedNode;
    }
    getGlobalVariableTemplate() {
        switch (this.options.target) {
            case ObfuscationTarget_1.ObfuscationTarget.BrowserNoEval:
                return (0, GlobalVariableNoEvalTemplate_1.GlobalVariableNoEvalTemplate)();
            case ObfuscationTarget_1.ObfuscationTarget.ServiceWorker:
                return (0, GlobalVariableServiceWorkerTemplate_1.GlobalVariableServiceWorkerTemplate)();
            default:
                return this.randomGenerator
                    .getRandomGenerator()
                    .pickone(AbstractCustomCodeHelper_1.globalVariableTemplateFunctions);
        }
    }
    getCodeHelperTemplate() {
        return '';
    }
};
AbstractCustomCodeHelper.globalVariableTemplateFunctions = [
    (0, GlobalVariableTemplate1_1.GlobalVariableTemplate1)(),
    (0, GlobalVariableTemplate2_1.GlobalVariableTemplate2)()
];
AbstractCustomCodeHelper = AbstractCustomCodeHelper_1 = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.ICustomCodeHelperFormatter)),
    __param(2, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.ICustomCodeHelperObfuscator)),
    __param(3, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IRandomGenerator)),
    __param(4, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [Function, Object, Object, Object, Object])
], AbstractCustomCodeHelper);
exports.AbstractCustomCodeHelper = AbstractCustomCodeHelper;
